<!-- eslint-disable max-lines -->
<template>
    <el-dialog title="分拨" class="distribution" :visible.sync="tableVisible" :before-close="handleCancel">
        <el-table :data="allocateData" v-loading="tableLoading" :row-class-name="tableRowClassName" @row-click="rowClick">
        <el-table-column property label width="50" center>
          <template slot-scope="scope">
            <el-radio
              v-model="radio"
              class="radio"
              :disabled="scope.row.disabled"
              :label="scope.$index"
              @change.native="getCurrentRow(scope.row, scope.$index)"
            >&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column min-width="140" property="customerAgingCode" show-overflow-tooltip label="时效编码"></el-table-column>
        <el-table-column min-width="300" prop="distributionWhNames" show-overflow-tooltip label="分拨仓"></el-table-column>
      </el-table>
      <div class="dis-footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="handleAllocate">确 定</el-button>
      </div>
    </el-dialog>
</template>
<script>
/* eslint-disable camelcase */
/* eslint-disable max-depth */
/* eslint-disable operator-linebreak */
/* eslint-disable max-statements */
/* eslint-disable no-magic-numbers */

import { getStorageData, getAllocate } from '../../../../api/dispatchCenter';
export default {
    props: {
        tableVisible: {
            type: Boolean,
            default: false
        },
        rowData: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            allocateData: [],
            radio: false,
            tableLoading: false,
            checkedWarehouse: []
        };
    },
    methods: {
        tableRowClassName ({ row, rowIndex }) {
            row.index = rowIndex;
        },
        rowClick(row, column, event) {
            this.getCurrentRow(row, row.index);
        },
        handleAllocate() {
            if (this.checkedWarehouse.length === 0) {
                this.$message.warning('至少勾选一个分拨仓库');
                return;
            };
            const check = this.checkedWarehouse;
            const obj = {
                customerAgingCode: check.customerAgingCode,
                isAging: check.isAging,
                distributionWhCode: check.distributionWhCode,
                distributionWhName: check.distributionWhName,
                taskNo: this.rowData.taskNo
            };
            if (+obj.isAging) {
                this.$confirm((obj.errorMsg || '时效不满足') + '，是否还需要继续分拨？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.getAllocates(obj);
                }).catch(() => {});
            } else {
                this.getAllocates(obj);
            }
        },
        getAllocates(obj) {
            getAllocate(obj).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('分拨成功');
                    this.radio = false;
                    this.$emit('distributionOk');
                };
            });
        },
        handleCancel() {
            this.$emit('update:tableVisible', false);
        },
        getTableList(data) {
            const params = { taskNo: data.taskNo, deliveryType: data.deliveryType };
            this.tableLoading = true;
            getStorageData(params).then(res => {
                if (res) {
                    if (!res.data || res.data.length <= 0) return this.$message.warning('无分拨仓数据，请核实是否已配置');
                    let errorMsg = '';
                    this.allocateData = res.data.map(item => {
                        if (item.stationList && item.stationList.length > 0) {
                            this.$set(item, 'disabled', false);
                            const stationList = item.stationList.map(s => s.whName);
                            item.distributionWhNames = stationList.join('-');
                        } else {
                            this.$set(item, 'disabled', true);
                        }
                        if (item.errorMsg && +item.isAging === 1) {
                            errorMsg += `<div style='line-height: 30px;'>
                                <span>${item.errorMsg}</span></div>`;
                        }
                        return item;
                    });
                    if (errorMsg) {
                        this.$message({
                            type: 'error',
                            duration: 5000,
                            dangerouslyUseHTMLString: true,
                            message: errorMsg,
                            showClose: true
                        });
                    }
                    if (this.allocateData.length === 1) {
                        const stationList = this.allocateData[0].stationList;
                        if (!stationList || stationList.length <= 0) {
                            this.radio = false;
                            this.checkedWarehouse = [];
                        } else {
                            this.radio = 0;
                            this.checkedWarehouse = { ...this.allocateData[0] };
                        }
                    }
                }
            }).finally(() => {
                this.tableLoading = false;
            });
        },
        getCurrentRow(data, index) {
            if (!data.stationList || data.stationList.length <= 0) {
                return this.$message.error(data.errorMsg || '没有仓库编码');
            }
            this.radio = index;
            this.checkedWarehouse = { ...data };
        }
    },
    mounted() {
        this.getTableList(this.rowData);
    }
};
</script>
<style lang="less">
    .distribution {
        .dis-footer {
            text-align: right;
            margin-top: 15px;
        }
    }
</style>
